var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('div',[_vm._v("Type - "+_vm._s(_vm.type))]),_c('div',[_vm._v("Props - "+_vm._s(_vm.propsString))]),_c('div',[_vm._v("Path - "+_vm._s(_vm.currentPathStringified))]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }